<template>
    <div class="main">
        <Banner :banner="banner"/>
        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                <Article :article="broadcast"/>
                <Article :article="review"/>
                <Tabs :tabs="tabs"/>
                <Article :article="review2"/>
                <Project :project="project"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'zgg',
    // meta配置
    metaInfo: {
        title: '【专题】' + 'SEC暂停中资企业通过VIE架构上市 互联网中概股公司将何去何从？',
        meta: [
            {
                name: 'keywords',
                content: '中概股 VIE'
            },
            {
                name: 'description',
                content: '8月17日，美国证券交易委员会(SEC)主席Gary Gensler在Twitter上表示，已要求SEC人员暂停处理中国公司通过VIE架构在美国上市。而在7月30日，Gensler就在一项声明指出了购买VIE公司股票时的风险性。近期，中美两国政府对中企境外上市问题均作了重要表态，此举将影响已上市的中概股互联网公司，而准备赴美IPO项目都已进入原地踏步状态。'
            }
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/zgg/banner.jpg'),
                title: [
                    'SEC暂停中资企业通过VIE架构上市',
                    '互联网中概股公司将何去何从？',
                ],
                text: '8月17日，美国证券交易委员会(SEC)主席Gary Gensler在Twitter上表示，已要求SEC人员暂停处理中国公司通过VIE架构在美国上市。而在7月30日，Gensler就在一项声明指出了购买VIE公司股票时的风险性。近期，中美两国政府对中企境外上市问题均作了重要表态，此举将影响已上市的中概股互联网公司，而准备赴美IPO项目都已进入原地踏步状态。'
            },

            // 置顶头条
            headlines: [
                {
                    title: 'SEC暂停中资企业通过VIE架构上市 互联网中概股公司将何去何从？',
                    url: '/detail--6599548.html'
                },
            ],

            // 滚动播报
            review: {
                title: {
                    topic: '滚动播报',
                    more: {
                        name: '我要投诉>',
                        url: '/Index/complain.html'
                    }
                },
                nav: [
                    {
                        value: 'VIE',
                        label: 'VIE'
                    },
                    {
                        value: '中概股',
                        label: '中概股'
                    },
                ],
                params: {
                    p: 1,
                    n: 5,
                    terms: 'VIE'
                },
            },
            
            // 暂缓IPO互联网公司

            tabs: {
                title: {
                    topic: '暂缓IPO互联网公司',
                    more: {
                        name: '企业库>',
                        url: 'http://cop.100ec.cn/'
                    }
                },
                list: [
                    {
                        label: '小红书',
                        content: `7月16日，有媒体报道称，小红书将暂停在美国上市。对此网经社第一时间向小红书求证，截至目前暂无回应。此前，在今年3月，小红书任命前花旗高管杨若担任CFO，并考虑最早今年赴美上市，估值超过100亿美元。（详见专题：<a href="http://www.100ec.cn/zt/xhszt/">传小红书或将暂停美国IPO计划</a>）`
                    },
                    {
                        label: '哈啰出行',
                        content: `7月28日，据美国证券交易委员会网站披露信息显示，基于应用程序的打车服务提供商哈啰出行取消了在美国上市的计划。而这距哈啰出行向美国证券交易委员会递交招股书仅有三个多月的时间。对此，哈啰出行表示，后续将会根据国家监管要求和资本市场环境，适时推进IPO事宜。（详见专题：<a href="http://www.100ec.cn/zt/hlcxIPO/">哈啰出行取消上市计划 蚂蚁金服是第一大股东</a>）`
                    },
                    {
                        label: '美菜网',
                        content: `7月23日，美菜网考虑将首次公开募股(IPO)地点从美国转移到香港。目前审议仍在进行中，美菜稍后或将决定是否继续其在美国上市的计划。对此，美菜网的一位代表称不予置评。今年5月，有媒体报道称美菜将于今年早些时候以保密形式申请在美国发行股份。（详见专题：<a href="http://www.100ec.cn/zt/mcw/">传美菜网拟赴美IPO  抢跑生鲜上市赛道？</a>）`
                    },
                    {
                        label: '多点新鲜',
                        content: `7月29日，据媒体报道，物美科技所有者另一家公司多点新鲜赴美IPO计划据悉同样暂缓。这家在线零售服务提供商由物美科技的董事长兼创始人张文中控股。物美科技提交给交易所的文件显示，多点向物美科技提供零售软件和电子商务数字服务。物美科技是多点收入的重要贡献者。（详见专题：<a href="http://www.100ec.cn/zt/dmrz/">传多点新鲜拟于今年赴美IPO 融资额度约5亿美元</a>）`
                    },
                    {
                        label: '天鹅到家',
                        content: `7月20日，据报道，知情人士7月19日称，中国家庭服务平台"天鹅到家"已暂停其赴美IPO计划。该知情人士称，天鹅到家本月早些时候已公开提交IPO申请，但不会很快启动上市。天鹅到家最初希望通过此次IPO至多融资5亿美元。（详见专题：<a href="https://www.100ec.cn/zt/tedjIPO/">天鹅到家赴美IPO平台GTV达88亿元 将冲刺中国家庭服务平台第一股</a>）`
                    },
                    {
                        label: '货拉拉',
                        content: `8月3日，传货拉拉目前正在考虑取消赴美上市，而转向香港上市，这样可能会一定程度上避免长时间的推移。对于这些消息，货拉拉也做出了回应，表示将会继续的对资本市场保持关注，具体的上市计划和时间表并没有确定下来。（详见专题：<a href="http://www.100ec.cn/zt/hllIPO/">同城赛道硝烟不断 货拉拉被传秘密申请美国IPO</a>）`
                    },
                    {
                        label: '福佑卡车',
                        content: `5月13日，福佑卡车向美国证监会递交了上市申请。2020年，福佑卡车收入为35.7亿元，净亏损达1.16亿元。截止到2020年年末，福佑卡车拥有约约83万名司机，超过11.2万名司机在平台上完成过订单。（详见专题：货运平台“福佑卡车”在美国递交招股书欲冲刺纳斯达克 <a href="http://www.100ec.cn/zt/fykcIPO/">http://www.100ec.cn/zt/fykcIPO/</a>）`
                    },
                    {
                        label: '喜马拉雅',
                        content: `7月初，有消息称播客平台喜马拉雅取消赴美IPO计划。4月30日，喜马拉雅向美国证监会提交招股书，准备赴美上市，估值有望超过50亿美元。喜马拉雅具体划分在音频领域，对标传统广播行业，属于互联网文化经营。如今喜马拉雅取消赴美上市，以目前盈利情况，其上市更是遥遥无期。（详见专题：<a href="http://www.100ec.cn/zt/xmly/">三年亏21亿元 在线音频平台“喜马拉雅”冲击IPO</a>）`
                    },
                    {
                        label: '极兔速递',
                        content: `今年4月1日，外媒报道极兔速递将会赴美上市，预计募集资金超过10亿美元。4月8日，极兔速递完成了一笔18亿美元的融资，由博裕资本领投 5.8 亿美元，红杉资本和高瓴同时跟投，投后估值达78亿美元。`
                    },
                    {
                        label: 'Keep',
                        content: `7月26日，据英国《金融时报》报道，运动社交平台Keep目前已取消赴美IPO计划。对此，Keep方面表示“不予置评”。早在今年3月，有媒体报道称，Keep将冲刺IPO，最快将于今年第二季度申请在美国上市。据Keep官方宣布的数据，截至2021年3月累积3亿用户，600万日活跃用户，4000万月活跃用户。`
                    },
                ],
                params: {
                    p: 1,
                    n: 5,
                    terms: '小红书'
                },
            },

            // 已上市互联网公司
            review2: {
                title: {
                    topic: '已上市互联网公司',
                    more: {
                        name: '企业库>',
                        url: 'http://cop.100ec.cn/'
                    }
                },
                nav: [
                    {
                        value: '阿里巴巴',
                        label: '阿里巴巴'
                    },
                    {
                        value: '拼多多',
                        label: '拼多多'
                    },
                    {
                        value: '京东',
                        label: '京东'
                    },
                    {
                        value: '滴滴',
                        label: '滴滴'
                    },
                    {
                        value: '贝壳',
                        label: '贝壳'
                    },
                    {
                        value: '唯品会',
                        label: '唯品会'
                    },
                    {
                        value: '每日优鲜',
                        label: '每日优鲜'
                    },
                    {
                        value: '叮咚买菜',
                        label: '叮咚买菜'
                    },
                    {
                        value: '携程',
                        label: '携程'
                    },
                    {
                        value: '途牛',
                        label: '途牛'
                    },
                    {
                        value: '寺库',
                        label: '寺库'
                    },
                    {
                        value: '达达',
                        label: '达达'
                    },
                    {
                        value: '云集',
                        label: '云集'
                    },
                    {
                        value: '蘑菇街',
                        label: '蘑菇街'
                    },
                    {
                        value: '1药网',
                        label: '1药网'
                    },
                ],
                params: {
                    p: 1,
                    n: 5,
                    terms: '阿里巴巴'
                },
            },

            // 相关专题
            project: {
                title: {
                    topic: '相关专题',
                },
                params: {
                    p: 1,
                    name: '',
                    title: '中概股'
                },
            }
        }
    },
}
</script>

<style>

</style>
